import { render, staticRenderFns } from "./OmsRejectDialog.vue?vue&type=template&id=d62d8f16"
import script from "./OmsRejectDialog.vue?vue&type=script&lang=js"
export * from "./OmsRejectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports